import * as React from 'react';
import { useContext } from 'react';
import { RootStoreContext } from '../../stores/RootStore';
import { observer } from 'mobx-react';
import { useIdleTimer } from 'react-idle-timer';

const RegistrationWizard = observer(() => {
  const { wizardStore: { currentStep }, registrationStore: { restart }, authStore } = useContext(RootStoreContext);

  useIdleTimer({
    timeout: 30000,
    onIdle: restart,
    disabled: !authStore.isAdminFlow
  });
  
  return <currentStep.component />
});

export default RegistrationWizard;
